<template>
  <Table
    id="riskTable"
    mode="records"
    :columns="computedColumns"
    :rows="filteredList"
    :total-rows="filteredList.length"
    :filters="filters"
    :filterOptions="filterOptions"
    :isLoading="isLoading"
    :pagination-options="paginationOptions"
    sorting-enabled
    @column-filter="onColumnFilters"
    @filters-clear="resetFilters"
    @handleCheckbox="onActiveChange"
  >
    <template #link="customData">
      <div class="truncate max-w-full whitespace-nowrap cursor-pointer">
        <span v-tippy :content="customData.customData.name">
          {{ customData.customData.name }}
        </span>
      </div>
    </template>
    <template #actions="{customData}">
      <div class="flex justify-around">
        <CloneButton
          :disabled="disabled"
          @click="$emit('clone', customData)"
        />
        <EditButton
          :disabled="customData.disabled || disabled"
          @click="$emit('edit', customData)"
        />
        <DeleteButton
          :disabled="customData.disabled || disabled"
          @click="$emit('delete', customData)"
        />
      </div>
    </template>
  
    <template #language="{customData}">
      <div class="flex gap-2 items-center">
        <div
          v-if="showFlag"
          class="flag-container"
        >
          <CountryFlag
            :country="getCountryCodeByLanguage(customData.iso_code)"
          />
        </div>
        <span class="capitalize">
          {{ customData.language_name }}
        </span>
      </div>
    </template>
  
  <template #state="{value}">
    <span class="capitalize">
      {{ String(value).toLocaleLowerCase() }}
    </span>
  </template>
  </Table>
</template>

<script>
// TODO handle actions (clone/change/remove)

// import { mapActions } from "vuex";
import Table from "@shared/dashboard-components/table-large";
import CountryFlag from 'vue-country-flag'
import {
  CloneButton,
  EditButton,
  DeleteButton,
} from "@shared/components/icon-buttons";

import { getCountryCodeByLanguage } from "@shared/plugins/i18n/utils";
import { getFilterOptions, getFilteredRows } from "@shared/dashboard-components/table-large/utils";
import { paginationOptions } from "@shared/dashboard-components/table-large/utils/constants";
import { capitalize } from "lodash";
import { checkPermission } from "@shared/utils/functions";

export default {
  name: "language-list",
  components: {
    Table,
    CloneButton,
    EditButton,
    DeleteButton,
    CountryFlag,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      filters: {},
      paginationOptions: { ...paginationOptions },
      // TODO handle proper properties
      columns: [
        {
          field: "active",
          config: {
            filter: {
              nameModifier: (el) => el.active
                ? this.$t("general.active")
                : this.$t("general.inactive"),
              customCheck: (el, filter) => {
                return filter?.value === el.active;
              }
            },
            type: "checkbox"
          },
          sortable: true,
          label: "actions.select",
          width: "100px",
        },
        {
          field: "name",
          config: {
            filter: true,
            type: "tooltip_text"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: "pages.localization.language_profile",
        },
        {
          field: "language",
          config: {
            filter: true,
            type: "tooltip_text",
            template: "language",
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: "pages.localization.language",
        },
        {
          field: "state",
          config: {
            filter: {
              nameModifier: (el) => capitalize(String(el.state).toLocaleLowerCase()),
            },
            type: "tooltip_text",
            template: "state",
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: "pages.localization.status",
        },
        {
          field: "actions",
          config: { filter: false, type: "actions" },
          tdClass: "truncate max-w-xs",
          width: "140px",
          sortable: false,
          label: "general.actions",
          hide: !checkPermission('localization.edit'),
        },
      ]
    };
  },
  computed: {
    computedColumns() {
      return this.columns
        .filter((el) => !el.hide)
        .map((el) => ({
          ...el,
          label: this.$t(el.label),
        }))
    },
    computedList() {
      const defaultList = [...this.list].filter((el) => el.is_default);
      const restList = [...this.list].filter((el) => !el.is_default);

      return [
        ...defaultList,
        ...restList,
      ]
        .map((el) => ({
          ...el,
          is_active: !!el.active,
          disabled: !!el.is_default || !checkPermission('localization.edit'),
        }));
    },
    filteredList() {
      return getFilteredRows(this.computedList, this.filters);
    },
    filterOptions() {
      return getFilterOptions(this.computedColumns, this.computedList)
    },
  },
  methods: {
    getCountryCodeByLanguage,
    onColumnFilters({ columnFilters }) {
      this.filters = columnFilters;
    },
    resetFilters() {
      this.filters = {};
    },
    onActiveChange(payload) {
      this.$emit("update:active", payload);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/functions.scss";

.flag-container {
  display: inline-flex;
  align-items: center;
  padding-bottom: toRem(5px);
}
</style>